import dayjs from 'dayjs'
import { NotificationFrequency, NotificationScheduleDto, Weekday } from '../sdk'

// The backend reads weekly times in this zone, so one-time sends are entered in it too
export const SWEDISH_TIME_ZONE = 'Europe/Stockholm'

export const WEEKDAY_LABELS: Record<Weekday, string> = {
  [Weekday.MONDAY]: 'Mon',
  [Weekday.TUESDAY]: 'Tue',
  [Weekday.WEDNESDAY]: 'Wed',
  [Weekday.THURSDAY]: 'Thu',
  [Weekday.FRIDAY]: 'Fri',
  [Weekday.SATURDAY]: 'Sat',
  [Weekday.SUNDAY]: 'Sun',
}

export const formatSwedishDateTime = (iso?: string | null): string =>
  iso ? dayjs(iso).tz(SWEDISH_TIME_ZONE).format('D MMM YYYY, HH:mm') : '—'

export const describeSchedule = (schedule: NotificationScheduleDto): string => {
  if (schedule.frequency === NotificationFrequency.ONCE) {
    return `Once, ${formatSwedishDateTime(schedule.sendAt)}`
  }

  const days = (schedule.weekdays ?? []).map(day => WEEKDAY_LABELS[day]).join(', ')
  return `Every ${days} at ${schedule.time}`
}
